export default __webpack_public_path__ + "static/media/bgFeaturedMatch.6561db35.png";